
import { paginationMixin } from "@/mixins/paginationMixin";
import Datepicker from 'vuejs-datepicker';
import { _ } from "vue-underscore";

export default {
	data: () => ({
		selectedEvaluator:{},
		evaluator:{},
		comments:"",
		evaluators: [],
		statesList:[],
		evaluations:[],
		tableData:[],
		error: "",
		searchText: "",
		showLoader: false,
		fromDate : new Date(),
		toDate : new Date(),
		sortBy:"",
		sortDirection:'asc'

	}),
	components: {
		Datepicker
	},
	mixins: [paginationMixin],
	computed: {
		selectedStudent() {
			return this.evaluations.filter(element => element.isSelected==true);
		}
	},
	methods: {
		applySort(sortBy){
			this.tableData = _.sortBy(this.tableData, function(column) { return column[sortBy]; });
			if(this.sortBy == sortBy && this.sortDirection=='asc'){
				this.sortDirection='desc';
				this.tableData = this.tableData.reverse();
			}else{
				this.sortDirection='asc';
			}
			this.sortBy = sortBy;
		},

		searchData(){
			const _vm =this;
			this.tableData = _.filter(this.evaluations,function(element){
				return (element.student_name.toLowerCase().indexOf(_vm.searchText.toLowerCase())>-1) ||
				(element.district_name.toLowerCase().indexOf(_vm.searchText.toLowerCase())>-1) ||
				(element.school_name.toLowerCase().indexOf(_vm.searchText.toLowerCase())>-1) ||
				(element.student_dob.toLowerCase().indexOf(_vm.searchText.toLowerCase())>-1) ||
				(element.compliance_date.toLowerCase().indexOf(_vm.searchText.toLowerCase())>-1) ||
				(element.zip_code.toLowerCase().indexOf(_vm.searchText.toLowerCase())>-1);
			})
		},

		convertDate(value){
			const date = new Date(value);
			return date.getFullYear() + "-" + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) +"-"+ (date.getDate() > 9 ? '' : '0') + date.getDate();
		},
		getOpenEvaluations() {
			let _vm = this;
			_vm.showLoader = true;
			this.axios
				.get("/get_report_cases_billed.php?from_date="+this.convertDate(this.fromDate)+"&to_date="+ this.convertDate(this.toDate))
				.then(function(response) {
					_vm.showLoader = false;
					response.data.data.forEach(element => {
						element["isSelected"] = false;
					});
					_vm.evaluations = response.data.data;
					_vm.tableData = response.data.data;

				})
				.catch(function(error) {
					console.log(error);
				});
		},
		// exportToExcel() {
		// 	const from = this.convertDate(this.fromDate);
		// 	const to = this.convertDate(this.toDate);
	
		// 	// Construct URL for export PHP script
		// 	const exportUrl = `/api/get_export_cases_billed_to_excel.php?from_date=${from}&to_date=${to}`;
	
		// 	// Trigger download
		// 	window.open(exportUrl, '_blank');
		// },
		exportToExcel() {
			const from = this.convertDate(this.fromDate);
			const to = this.convertDate(this.toDate);
		
			this.axios({
				method: 'get',
				url: `/get_export_cases_billed_to_excel.php`,
				params: { from_date: from, to_date: to },
				responseType: 'blob'
			})
			.then(response => {
				const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
				const link = document.createElement('a');
				link.href = window.URL.createObjectURL(blob);
				link.setAttribute('download', 'invoice_report.xlsx');
				document.body.appendChild(link);
				link.click();
				link.remove();
		
				this.$toast?.success("Invoices Excel file was downloaded!");
			})
			.catch(error => {
				console.error("Excel download error:", error);
				this.$toast?.error("Failed to download Excel file.");
			});
		}
		
		
			

	},
	mounted() {
		this.getOpenEvaluations();
	}
};
